import React, { useState, useEffect, useRef } from 'react';
import { InputMask } from '@react-input/mask';
import Select from "react-select";
import DatePicker, { dateHelpers } from '../../../components/utils/datepicker';
import TimePicker from '../../../components/utils/timepicker';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import heic2any from "heic2any";

import { validarCPF, validarEmail } from '../../../components/utils/validacoes';
import { autoCompleteBancos } from "../../../components/utils/autocompletes";
import { FaRegSave, FaTimes, FaTrashAlt, FaPlus, FaRegTrashAlt  } from 'react-icons/fa';

const PessoaModal = ({ pessoa, onClose, onPessoaAtualizada }) => {
	const [tituloModal, setTituloModal] = useState("");
	const [loadingImage, setLoadingImage] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [activeTab, setActiveTab] = useState('geral');
	const [opcoesOndeConheceu, setOpcoesOndeConheceu] = useState([]);
	const { inputPesquisaBanco, bancosOptions, handleAutoCompleteBancos, handleFocusBancos } = autoCompleteBancos();
	const [gestorasOptions, setGestorasOptions] = useState([]);
	const [unidadesOptions, setUnidadesOptions] = useState([]);
	const [tiposAcesso, setTiposAcesso] = useState([]);
	const [formData, setFormData] = useState({
		nome: '',
		data_nascimento: '',
		sexo: '',
		cpf: '',
		cnpj: '',
		e_estrangeiro: false,
		documento_estrangeiro: '',
		ddi: '+55',
		telefone: '',
		celular: '',
		email: '',
		observacao: '',
		cep: '',
		rua: '',
		endereco: '',
		numero: '',
		estado: '',
		cidade: '',
		bairro: '',
		complemento: '',
		fotoum: '',
		e_cliente: false,
		e_colaborador: false,
		e_fornecedor: false,

		rg: '',
		profissao: '',
		como_conheceu: '',
		sistema_origem: '',
		fotodois: '',
		fototres: '',
		fotoquatro: '',
		fotocinco: '',
		fotoseis: '',

		tipo_pix: '',
		pix: '',
		gestora_designacao_id: '',
		senha: '',
		tipo_acesso_id: '',

		nome_fantasia: '',
		razao_social: '',
		responsavel: '',
		banco: '',
		tipo_conta: 'corrente',
		agencia: '',
		conta: '',
		conta_digito: '',
		nome_titular: '',
		documento_titular: '',

		horariosPadrao: [],
		horariosExcecao: [],
		unidadesVinculadas: []
	});

	const customStyles = {
		menu: (provided) => ({
			...provided,
			whiteSpace: "pre-line",
		}),
		option: (provided) => ({
			...provided,
			whiteSpace: "pre-wrap",
			wordBreak: "break-word",
		}),
	};

	const handleSelectChange = async (name, value) => {
		setFormData((prevState) => ({
			...prevState,
			[name]: value || "",
		}));

		if (name === 'gestora_designacao_id') {
			setFormData((prevState) => ({
				...prevState,
				[name]: value || "",
			}));
			if (value) {
				fetchUnidades(value);
			} else {
				setUnidadesOptions([]);
			}
		}
	};

	const fetchOpcoesOndeConheceu = async () => {
		try {
			const response = await api.get('/configuracoes-onde-conheceu');
			setOpcoesOndeConheceu(response.data || []);
		} catch (error) {
			setOpcoesOndeConheceu([]);
		}
	};

	const fetchGestoras = async () => {
		try {
			const response = await api.get('/gestoras');
			setGestorasOptions(response.data.gestoras || []);
		} catch (error) {
			setGestorasOptions([]);
		}
	};

	const fetchUnidades = async (gestoraId = null) => {
		try {
			let url = '/unidades';
			if (gestoraId) {
				url = `/gestoras/${gestoraId}/unidades`;
			}
			const response = await api.get(url);
			setUnidadesOptions(response.data.unidades || []);
		} catch (error) {
			setUnidadesOptions([]);
		}
	};

	const fetchTiposAcesso = async () => {
		try {
			const response = await api.get('/tipos-de-acesso');
			setTiposAcesso(response.data.records || []);
		} catch (error) {
			setTiposAcesso([]);
		}
	};

	useEffect(() => {
		fetchOpcoesOndeConheceu();
		fetchGestoras();
		fetchUnidades();
		fetchTiposAcesso();
	}, []);

	useEffect(() => {
		if (pessoa != null) {
			const horariosConvertidos = pessoa.dadosColaborador?.horariosPadrao ? converterHorariosPadrao(pessoa.dadosColaborador.horariosPadrao) : [];
			const horariosExcecaoConvertidos = pessoa.dadosColaborador?.horariosExcecao ? converterHorariosExcecao(pessoa.dadosColaborador.horariosExcecao) : [];
			
			setFormData({
				...pessoa,
				data_nascimento: pessoa.data_nascimento ? pessoa.data_nascimento.split('-').reverse().join('/') : '',

				rg: pessoa.dadosCliente?.rg || '',
				profissao: pessoa.dadosCliente?.profissao || '',
				como_conheceu: pessoa.dadosCliente?.como_conheceu || '',
				sistema_origem: pessoa.dadosCliente?.sistema_origem || '',
				fotodois: pessoa.dadosCliente?.fotodois || '',
				fototres: pessoa.dadosCliente?.fototres || '',
				fotoquatro: pessoa.dadosCliente?.fotoquatro || '',
				fotocinco: pessoa.dadosCliente?.fotocinco || '',
				fotoseis: pessoa.dadosCliente?.fotoseis || '',

				tipo_pix: pessoa.dadosColaborador?.tipo_pix || '',
				pix: pessoa.dadosColaborador?.pix || '',
				gestora_designacao_id: pessoa.dadosColaborador?.gestora_designacao_id || '',
				senha: pessoa.dadosColaborador?.senha || '',
				tipo_acesso_id: pessoa.dadosColaborador?.tipo_acesso_id || '',

				nome_fantasia: pessoa.dadosFornecedor?.nome_fantasia || '',
				razao_social: pessoa.dadosFornecedor?.razao_social || '',
				responsavel: pessoa.dadosFornecedor?.responsavel || '',
				banco: pessoa.dadosFornecedor?.dadosBanco ? { value: pessoa.dadosFornecedor.dadosBanco.id, label: pessoa.dadosFornecedor.dadosBanco.nome } : '',
				tipo_conta: pessoa.dadosFornecedor?.tipo_conta || 'corrente',
				agencia: pessoa.dadosFornecedor?.agencia || '',
				conta: pessoa.dadosFornecedor?.conta ? pessoa.dadosFornecedor.conta.slice(0, -1) : '',
				conta_digito: pessoa.dadosFornecedor?.conta ? pessoa.dadosFornecedor.conta.slice(-1) : '',
				nome_titular: pessoa.dadosFornecedor?.nome_titular || '',
				documento_titular: pessoa.dadosFornecedor?.documento_titular || '',

				horariosPadrao: horariosConvertidos,
				horariosExcecao: horariosExcecaoConvertidos,
				unidadesVinculadas: (pessoa.dadosColaborador?.unidadesVinculadas || []).map(vinculo => {
					return {
						id: vinculo.id,
						unidade_id: vinculo.unidade_id || vinculo.unidade?.id,
						gestora_id: vinculo.gestora_id || pessoa.dadosColaborador?.gestora_designacao_id,
						nome: vinculo.unidade?.nome || ''
					};
				})
			});
			if (pessoa.dadosColaborador?.gestora_designacao_id) {
				fetchUnidades(pessoa.dadosColaborador.gestora_designacao_id);
			}
			
			setTituloModal('Editar Pessoa');
		}
		else {
			setTituloModal('Nova Pessoa');
			const horarioPadraoVazio = {
				id: `temp_${new Date().getTime()}`,
				hora_inicio: '',
				hora_termino: '',
				dias_semana: {
					segunda: false,
					terca: false,
					quarta: false,
					quinta: false,
					sexta: false,
					sabado: false,
					domingo: false
				}
			};
			setFormData(prev => ({
				...prev,
				horariosPadrao: [horarioPadraoVazio]
			}));
		}
	}, [pessoa]);


	const estados = [
		'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
		'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
	];

	const fileInputRefs = useRef([]);

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		const newFormData = {
			...formData,
			[name]: type === 'checkbox' ? checked : value
		};

		if (name === 'e_cliente' && !checked && activeTab === 'cliente') {
			setActiveTab('geral');
		}

		if (name === 'e_colaborador' && !checked && activeTab === 'colaborador') {
			setActiveTab('geral');
		}

		if (name === 'e_fornecedor' && !checked && activeTab === 'fornecedor') {
			setActiveTab('geral');
		}

		setFormData(newFormData);
	};

	const handleDateChange = (field, formattedDate) => {
		setFormData(prev => ({
			...prev,
			[field]: formattedDate
		}));
	};

	const handleTimeChangeHorarioPadrao = (id, field, date) => {
		if (date) {
			const timeString = date.getHours().toString().padStart(2, '0') + ':' +
							  date.getMinutes().toString().padStart(2, '0');
			handleChangeHorarioPadrao(id, field, timeString);
		} else {
			handleChangeHorarioPadrao(id, field, '');
		}
	};

	const handleTimeChangeHorarioExcecao = (id, field, date) => {
		if (date) {
			const timeString = date.getHours().toString().padStart(2, '0') + ':' +
							  date.getMinutes().toString().padStart(2, '0');
			handleChangeHorarioExcecao(id, field, timeString);
		} else {
			handleChangeHorarioExcecao(id, field, '');
		}
	};

	const handleDateChangeHorarioExcecao = (id, formattedDate) => {
		handleChangeHorarioExcecao(id, 'data_especifica', formattedDate);
	};

	const stringToTime = (timeString) => {
		if (!timeString || !timeString.includes(':')) return null;
		const [hours, minutes] = timeString.split(':');
		const date = new Date();
		date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
		return date;
	};

	const handleFileChange = (e, field) => {
		let file = e.target.files[0];

		if (file) {
			setLoadingImage((prev) => ({ ...prev, [field]: true }));
			setIsLoading(true);
			if (file.name.toLowerCase().endsWith('.heic')) {
				const reader = new FileReader();

				reader.onload = async (e) => {
					try {
						const blob = await heic2any({
							blob: new Blob([e.target.result]),
							toType: "image/png",
						});

						file = new File([blob], file.name.replace('.heic', '.png'), { type: "image/png" });
						compressBase64(file).then((compressedBase64) => {
							setFormData((prev) => ({ ...prev, [field]: compressedBase64 }));
							setLoadingImage((prev) => ({ ...prev, [field]: false }));
							setIsLoading(false);
						});

					} catch (error) {
						setLoadingImage((prev) => ({ ...prev, [field]: false }));
						setIsLoading(false);
					}
				};
				reader.readAsArrayBuffer(file);
			} else {
				compressBase64(file).then((compressedBase64) => {
					setFormData((prev) => ({ ...prev, [field]: compressedBase64 }));
					setLoadingImage((prev) => ({ ...prev, [field]: false }));
					setIsLoading(false);
				});
			}
		}
	};

	const compressBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (event) => {
				window.CompressBase64.default(event.target.result, {
					width: 400,
					type: 'image/png',
					max: 200,
					min: 20,
					quality: 1,
				})
					.then((result) => resolve(result))
					.catch((err) => reject(err));
			};
			reader.onerror = (error) => reject(error);
		});
	};

	const handleOpenImage = (base64) => {
		const byteCharacters = atob(base64.split(',')[1]);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], { type: 'image/png' });

		const blobUrl = URL.createObjectURL(blob);
		window.open(blobUrl, '_blank');

		setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
	};

	const handleBlockClick = (index) => {
		fileInputRefs.current[index].click();
	};

	const handleAdicionarHorarioPadrao = () => {
		const novoHorario = {
			id: `temp_${new Date().getTime()}`,
			unidade_id: '',
			hora_inicio: '',
			hora_termino: '',
			dias_semana: {
				segunda: false,
				terca: false,
				quarta: false,
				quinta: false,
				sexta: false,
				sabado: false,
				domingo: false
			}
		};

		setFormData((prevState) => ({
			...prevState,
			horariosPadrao: [...prevState.horariosPadrao, novoHorario],
		}));
	};

	const handleRemoverHorarioPadrao = (id) => {
		setFormData((prevState) => ({
			...prevState,
			horariosPadrao: prevState.horariosPadrao.filter((horario) => horario.id !== id),
		}));
	};

	const handleChangeHorarioPadrao = (id, field, value) => {
		setFormData((prevState) => ({
			...prevState,
			horariosPadrao: prevState.horariosPadrao.map((horario) =>
				horario.id === id ? { ...horario, [field]: value } : horario
			),
		}));
	};

	const handleChangeDiaSemana = (horarioId, dia, checked) => {
		setFormData((prevState) => ({
			...prevState,
			horariosPadrao: prevState.horariosPadrao.map((horario) =>
				horario.id === horarioId
					? {
						...horario,
						dias_semana: {
							...horario.dias_semana,
							[dia]: checked
						}
					}
					: horario
			),
		}));
	};

	const handleAdicionarHorarioExcecao = () => {
		const novoHorario = {
			id: `temp_${new Date().getTime()}`,
			unidade_id: '',
			data_especifica: '',
			hora_inicio: '',
			hora_termino: '',
			tipo_excecao: 'horario_diferente'
		};

		setFormData((prevState) => ({
			...prevState,
			horariosExcecao: [...prevState.horariosExcecao, novoHorario],
		}));
	};

	const handleRemoverHorarioExcecao = (id) => {
		setFormData((prevState) => ({
			...prevState,
			horariosExcecao: prevState.horariosExcecao.filter((horario) => horario.id !== id),
		}));
	};

	const handleChangeHorarioExcecao = (id, field, value) => {
		setFormData((prevState) => ({
			...prevState,
			horariosExcecao: prevState.horariosExcecao.map((horario) =>
				horario.id === id ? { ...horario, [field]: value } : horario
			),
		}));
	};

	const handleAdicionarUnidadeVinculada = () => {
		if (!formData.gestora_designacao_id) {
			Swal.fire('Atenção', 'Selecione uma gestora primeiro', 'warning');
			return;
		}
		
		const novaUnidade = {
			id: `temp_${new Date().getTime()}`,
			gestora_id: formData.gestora_designacao_id,
			unidade_id: ''
		};
		
		setFormData((prevState) => ({
			...prevState,
			unidadesVinculadas: [...prevState.unidadesVinculadas, novaUnidade]
		}));
	};

	const handleRemoverUnidadeVinculada = (id) => {
		setFormData((prevState) => ({
			...prevState,
			unidadesVinculadas: prevState.unidadesVinculadas.filter(unidade => unidade.id !== id)
		}));
	};

	const handleChangeUnidadeVinculada = (id, unidadeId) => {
		setFormData((prevState) => ({
			...prevState,
			unidadesVinculadas: prevState.unidadesVinculadas.map(unidade => 
				unidade.id === id ? { 
					...unidade, 
					unidade_id: unidadeId,
					gestora_id: prevState.gestora_designacao_id 
				} : unidade
			)
		}));
	};

	const converterHorariosPadrao = (horariosApi) => {
		if (!Array.isArray(horariosApi)) return [];
		
		const horariosAgrupados = {};
		
		horariosApi.forEach((horario) => {
			const horaInicio = horario.hora_inicio ? horario.hora_inicio.substring(0, 5) : '';
			const horaTermino = horario.hora_termino ? horario.hora_termino.substring(0, 5) : '';
			const chave = `${horaInicio}-${horaTermino}`;
			
			if (!horariosAgrupados[chave]) {
				horariosAgrupados[chave] = {
					id: `temp_${new Date().getTime()}_${Math.random()}`,
					unidade_id: horario.unidade_id || '',
					hora_inicio: horaInicio,
					hora_termino: horaTermino,
					dias_semana: {
						segunda: false, terca: false, quarta: false, quinta: false, sexta: false, sabado: false, domingo: false
					},
					horariosOriginais: []
				};
			}
			
			const diasMap = {
				0: 'domingo',
				1: 'segunda',
				2: 'terca',
				3: 'quarta',
				4: 'quinta',
				5: 'sexta',
				6: 'sabado'
			};
			
			const diaSemana = diasMap[horario.dia_semana];
			if (diaSemana) {
				horariosAgrupados[chave].dias_semana[diaSemana] = true;
			}
			
			horariosAgrupados[chave].horariosOriginais.push(horario);
		});
		
		return Object.values(horariosAgrupados);
	};

	const converterHorariosExcecao = (horariosApi) => {
		if (!Array.isArray(horariosApi)) return [];
		
		return horariosApi.map((horario) => {
			let dataFormatada = '';
			if (horario.data_especifica) {
				const [ano, mes, dia] = horario.data_especifica.split('-');
				dataFormatada = `${dia}/${mes}/${ano}`;
			}
			
			const horaInicio = horario.hora_inicio ? horario.hora_inicio.substring(0, 5) : '';
			const horaTermino = horario.hora_termino ? horario.hora_termino.substring(0, 5) : '';
			
			return {
				id: horario.id,
				unidade_id: horario.unidade_id || '',
				data_especifica: dataFormatada,
				hora_inicio: horaInicio,
				hora_termino: horaTermino,
				tipo_excecao: horario.tipo_excecao
			};
		});
	};

	const buscarEndereco = async () => {
		const cepLimpo = formData.cep.replace("-", "");
		if (cepLimpo.length === 8) {
			try {
				const response = await api.get(`/cep/${cepLimpo}`);

				setFormData({
					...formData,
					estado: response.data.UF,
					cidade: response.data.CIDADE,
					bairro: response.data.BAIRRO,
					rua: response.data.RUA,
				});
			} catch (error) {
				throw error;
			}
		}
	};

	const formatarDataRequisicao = (data) => {
		const [dia, mes, ano] = data.split('/');
		return `${ano}-${mes}-${dia}`;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!formData.e_cliente && !formData.e_colaborador && !formData.e_fornecedor) {
			Swal.fire('Erro', 'Selecione pelo menos um tipo de pessoa (Cliente, Colaborador ou Fornecedor)', 'error');
			return;
		}

		const camposObrigatorios = [
			{ campo: 'nome', label: 'Nome' },
			{ campo: 'data_nascimento', label: 'Data de Nascimento' },
			{ campo: 'sexo', label: 'Sexo' },
			{ campo: 'email', label: 'E-mail' },
			{ campo: 'celular', label: 'Celular' }
		];

		if (formData.e_estrangeiro) {
			camposObrigatorios.push({ campo: 'documento_estrangeiro', label: 'Documento Estrangeiro' });
		} else {
			const isApenasFornecedor = formData.e_fornecedor && !formData.e_cliente && !formData.e_colaborador;
			if (!isApenasFornecedor) {
				camposObrigatorios.push({ campo: 'cpf', label: 'CPF' });
			}
		}

		if (formData.e_cliente) {
			camposObrigatorios.push({ campo: 'rg', label: 'RG' });
		}

		if (formData.e_fornecedor) {
			camposObrigatorios.push({ campo: 'banco', label: 'Banco' });

			const isApenasFornecedor = formData.e_fornecedor && !formData.e_cliente && !formData.e_colaborador;
			if (isApenasFornecedor) {
				camposObrigatorios.push({ campo: 'nome_fantasia', label: 'Nome Fantasia' });
				camposObrigatorios.push({ campo: 'razao_social', label: 'Razão Social' });
				camposObrigatorios.push({ campo: 'cnpj', label: 'CNPJ' });
			}
		}

		if (formData.e_colaborador) {
			if (!formData.tipo_acesso_id) {
				Swal.fire('Erro', 'Selecione um tipo de acesso para o colaborador', 'error');
				return;
			}

			if (!formData.gestora_designacao_id) {
				Swal.fire('Erro', 'Selecione uma gestora para o colaborador', 'error');
				return;
			}

			const temHorarios = formData.horariosPadrao && formData.horariosPadrao.length > 0;
			const temUnidades = formData.unidadesVinculadas && formData.unidadesVinculadas.length > 0;

			if (temHorarios && !temUnidades) {
				Swal.fire('Erro', 'Colaborador com horários deve ter pelo menos uma unidade vinculada', 'error');
				return;
			}

			if (temHorarios) {
				const horariosComUnidadeInvalida = formData.horariosPadrao.filter(horario =>
					!horario.unidade_id || horario.unidade_id === ''
				);

				if (horariosComUnidadeInvalida.length > 0) {
					Swal.fire('Erro', 'Todos os horários padrão devem ter uma unidade selecionada', 'error');
					return;
				}
			}
		}

		const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
			const valor = formData[campo];

			if (typeof valor === 'string') return !valor.trim();

			if (typeof valor === 'object' && valor !== null) return !valor.value;

			return !valor;
		});

		if (camposInvalidos.length > 0) {
			Swal.fire(
				'Erro',
				`Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
				'error'
			);
			return;
		}

		// Comentado: Validação de formato do CPF
		// if (!formData.e_estrangeiro && formData.cpf && !validarCPF(formData.cpf)) {
		// 	Swal.fire('Erro', 'CPF inválido.', 'error');
		// 	return;
		// }

		// Comentado: Validação de formato do e-mail
		// if (formData.email && !validarEmail(formData.email)) {
		// 	Swal.fire('Erro', 'E-mail inválido.', 'error');
		// 	return;
		// }

		const data = {
			...formData,
			data_nascimento: formData.data_nascimento ? formatarDataRequisicao(formData.data_nascimento) : null
		};

		if (formData.e_cliente) {
			data.dadosCliente = {
				rg: formData.rg,
				profissao: formData.profissao,
				como_conheceu: formData.como_conheceu,
				sistema_origem: formData.sistema_origem,
				fotodois: formData.fotodois,
				fototres: formData.fototres,
				fotoquatro: formData.fotoquatro,
				fotocinco: formData.fotocinco,
				fotoseis: formData.fotoseis
			};
		}

		if (formData.e_colaborador) {
			const horariosPadraoFormatados = formData.horariosPadrao.map(horario => {
				const diasSelecionados = [];
				if (horario.dias_semana.domingo) diasSelecionados.push(0);
				if (horario.dias_semana.segunda) diasSelecionados.push(1);
				if (horario.dias_semana.terca) diasSelecionados.push(2);
				if (horario.dias_semana.quarta) diasSelecionados.push(3);
				if (horario.dias_semana.quinta) diasSelecionados.push(4);
				if (horario.dias_semana.sexta) diasSelecionados.push(5);
				if (horario.dias_semana.sabado) diasSelecionados.push(6);

				return diasSelecionados.map(dia => {
					const horarioOriginal = horario.horariosOriginais?.find(h => h.dia_semana === dia);
					
					return {
						...(horarioOriginal && !horarioOriginal.id.toString().startsWith('temp_') ? { id: horarioOriginal.id } : {}),
						unidade_id: horario.unidade_id,
						dia_semana: dia,
						hora_inicio: horario.hora_inicio,
						hora_termino: horario.hora_termino
					};
				});
			}).flat();

			data.dadosColaborador = {
				tipo_pix: formData.tipo_pix,
				pix: formData.pix,
				gestora_designacao_id: formData.gestora_designacao_id ? parseInt(formData.gestora_designacao_id) : null,
				senha: formData.senha,
				tipo_acesso_id: formData.tipo_acesso_id,
				horariosPadrao: horariosPadraoFormatados,
				horariosExcecao: formData.horariosExcecao.map(excecao => {
					const excecaoFormatada = {
						...excecao,
						data_especifica: excecao.data_especifica ? formatarDataRequisicao(excecao.data_especifica) : ''
					};
					if (excecao.id && excecao.id.toString().startsWith('temp_')) {
						delete excecaoFormatada.id;
					}
					return excecaoFormatada;
				}),
				unidadesVinculadas: formData.unidadesVinculadas.map(unidade => ({
					gestora_id: unidade.gestora_id,
					unidade_id: unidade.unidade_id
				}))
			};
		}

		if (formData.e_fornecedor) {
			data.dadosFornecedor = {
				nome_fantasia: formData.nome_fantasia,
				razao_social: formData.razao_social,
				responsavel: formData.responsavel,
				banco: formData.banco?.value || formData.banco,
				tipo_conta: formData.tipo_conta,
				agencia: formData.agencia,
				conta: formData.conta + formData.conta_digito,
				nome_titular: formData.nome_titular,
				documento_titular: formData.documento_titular
			};
		}

		delete data.rg;
		delete data.profissao;
		delete data.como_conheceu;
		delete data.sistema_origem;
		delete data.fotodois;
		delete data.fototres;
		delete data.fotoquatro;
		delete data.fotocinco;
		delete data.fotoseis;
		delete data.tipo_pix;
		delete data.pix;
		delete data.gestora_designacao_id;
		delete data.senha;
		delete data.tipo_acesso_id;
		delete data.nome_fantasia;
		delete data.razao_social;
		delete data.responsavel;
		delete data.banco;
		delete data.tipo_conta;
		delete data.agencia;
		delete data.conta;
		delete data.conta_digito;
		delete data.nome_titular;
		delete data.documento_titular;
		delete data.horariosPadrao;
		delete data.horariosExcecao;

		Swal.fire({
			title: "Carregando...",
			allowOutsideClick: false,
			allowEscapeKey: false,
			showConfirmButton: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		try {
			if (pessoa != null) {
				await api.put(`/pessoas/${pessoa.id}`, data);
			}
			else {
				await api.post(`/pessoas`, data);
			}

			onPessoaAtualizada();
			onClose();
			Swal.fire('Sucesso', 'Pessoa salva com sucesso!', 'success');
		}
		catch (error) {
			Swal.close();
			Swal.fire('Erro', `${error.response.data.message || 'Erro ao salvar pessoa'}`, 'error');
		}
	};

	return (
		<div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
			<div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div className="modal-content" onClick={(e) => e.stopPropagation()}>
					<div className="modal-header">
						<h4 className="fw-bold mt-2">{tituloModal}</h4>
						<button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
					</div>
					<div className="modal-body">
						<ul className="nav nav-tabs mt-3">
							<li className="nav-item">
								<a
									className={`nav-link ${activeTab === 'geral' ? 'active' : ''}`}
									onClick={() => setActiveTab('geral')}
									style={{ cursor: 'pointer' }}
								>
									Informações Gerais
								</a>
							</li>
							{formData.e_cliente && (
								<li className="nav-item">
									<a
										className={`nav-link ${activeTab === 'cliente' ? 'active' : ''}`}
										onClick={() => setActiveTab('cliente')}
										style={{ cursor: 'pointer' }}
									>
										Cliente
									</a>
								</li>
							)}
							{formData.e_colaborador && (
								<li className="nav-item">
									<a
										className={`nav-link ${activeTab === 'colaborador' ? 'active' : ''}`}
										onClick={() => setActiveTab('colaborador')}
										style={{ cursor: 'pointer' }}
									>
										Colaborador
									</a>
								</li>
							)}
							{formData.e_fornecedor && (
								<li className="nav-item">
									<a
										className={`nav-link ${activeTab === 'fornecedor' ? 'active' : ''}`}
										onClick={() => setActiveTab('fornecedor')}
										style={{ cursor: 'pointer' }}
									>
										Fornecedor
									</a>
								</li>
							)}
						</ul>

						<form>
							{activeTab === 'geral' && (
								<>
									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Tipo de Pessoa</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											<div className="form-check">
												<input
													className="form-check-input"
													type="checkbox"
													name="e_cliente"
													id="e_cliente"
													checked={formData.e_cliente}
													onChange={handleChange}
												/>
												<label className="form-check-label" htmlFor="e_cliente">
													É Cliente
												</label>
											</div>
										</div>
										<div className="col-lg-4 col-md-12">
											<div className="form-check">
												<input
													className="form-check-input"
													type="checkbox"
													name="e_colaborador"
													id="e_colaborador"
													checked={formData.e_colaborador}
													onChange={handleChange}
												/>
												<label className="form-check-label" htmlFor="e_colaborador">
													É Colaborador
												</label>
											</div>
										</div>
										<div className="col-lg-4 col-md-12">
											<div className="form-check">
												<input
													className="form-check-input"
													type="checkbox"
													name="e_fornecedor"
													id="e_fornecedor"
													checked={formData.e_fornecedor}
													onChange={handleChange}
												/>
												<label className="form-check-label" htmlFor="e_fornecedor">
													É Fornecedor
												</label>
											</div>
										</div>
									</div>

									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Dados Pessoais</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-3 col-md-12">
											<label className="form-label fw-bold">Foto</label>
											{formData.fotoum ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fotoum}
															alt="Foto"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fotoum)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fotoum: '' })}
														>
															<FaTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(0)}>
													{loadingImage['fotoum'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fotoum')}
																ref={(el) => (fileInputRefs.current[0] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>
										<div className="col-lg-9 col-md-12">
											<div className="row">
												<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">Nome</label>
													<input
														className="form-control"
														type="text"
														name="nome"
														value={formData.nome}
														onChange={(e) => setFormData({ ...formData, nome: e.target.value.toUpperCase() })}
														required
													/>
												</div>
												<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">Data de Nascimento</label>
													<DatePicker
														selected={dateHelpers.stringToDate(formData.data_nascimento)}
														onChange={dateHelpers.createOnChangeHandler((formattedDate) =>
															handleDateChange('data_nascimento', formattedDate)
														)}
														className="form-control"
														popperProps={{
															strategy: "fixed"
														}}
													/>
												</div>
												<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">Sexo</label>
													<select
														name="sexo"
														className="form-control"
														value={formData.sexo}
														onChange={handleChange}
													>
														<option value="">Selecione...</option>
														<option value="M">Masculino</option>
														<option value="F">Feminino</option>
														<option value="O">Outro</option>
													</select>
												</div>
											</div>
											<div className="row mt-3">
												<div className="col-lg-4 col-md-12">
													<label className="form-label fw-bold">CPF</label>
													<InputMask
														mask="___.___.___-__"
														replacement={{ _: /\d/ }}
														name="cpf"
														className="form-control"
														value={formData.cpf}
														onChange={handleChange}
														disabled={formData.e_estrangeiro}
													/>
												</div>
												<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">CNPJ</label>
													<InputMask
														mask="__.___.___/____-__"
														replacement={{ _: /\d/ }}
														name="cnpj"
														className="form-control"
														value={formData.cnpj}
														onChange={handleChange}
													/>
												</div>
												<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">E-mail</label>
													<input
														type="email"
														name="email"
														autoComplete="off"
														className="form-control"
														value={formData.email}
														onChange={handleChange}
													/>
												</div>
											</div>
											<div className="row mt-3">
												<div className="col-lg-2 col-md-12">
													<label className="form-label fw-bold">DDI</label>
													<input
														type="text"
														name="ddi"
														className="form-control"
														value={formData.ddi}
														onChange={handleChange}
													/>
												</div>
												<div className="col-lg-5 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">Celular</label>
													{formData.ddi === '+55' ? (
														<InputMask
															mask="(__) _____-____"
															replacement={{ _: /\d/ }}
															name="celular"
															autoComplete="off"
															className="form-control"
															value={formData.celular}
															onChange={handleChange}
															placeholder="(XX) XXXXX-XXXX"
														/>
													) : (
														<input
															type="text"
															name="celular"
															autoComplete="off"
															className="form-control"
															value={formData.celular}
															onChange={handleChange}
															placeholder="Digite o celular"
														/>
													)}
												</div>
												<div className="col-lg-5 col-md-12 mt-lg-0 mt-3">
													<label className="form-label fw-bold">Telefone</label>
													{formData.ddi === '+55' ? (
														<InputMask
															mask="(__) ____-____"
															replacement={{ _: /\d/ }}
															name="telefone"
															autoComplete="off"
															className="form-control"
															value={formData.telefone}
															onChange={handleChange}
															placeholder="(XX) XXXX-XXXX"
														/>
													) : (
														<input
															type="text"
															name="telefone"
															autoComplete="off"
															className="form-control"
															value={formData.telefone}
															onChange={handleChange}
															placeholder="Digite o telefone"
														/>
													)}
												</div>
											</div>
										</div>
									</div>

									<div className="row mt-3">
										<div className="col-lg-3 col-md-12 mt-lg-0 mt-3">
											<div className="form-check mt-4">
												<input
													className="form-check-input"
													type="checkbox"
													name="e_estrangeiro"
													id="e_estrangeiro"
													checked={formData.e_estrangeiro}
													onChange={handleChange}
												/>
												<label className="form-check-label fw-bold" htmlFor="e_estrangeiro">
													É Estrangeiro
												</label>
											</div>
										</div>
										<div className="col-lg-9 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Documento Estrangeiro</label>
											<input
												type="text"
												name="documento_estrangeiro"
												className="form-control"
												value={formData.documento_estrangeiro}
												onChange={handleChange}
												disabled={!formData.e_estrangeiro}
											/>
										</div>
									</div>

									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Endereço</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-3 col-md-12">
											<label className="form-label fw-bold">CEP</label>
											<InputMask
												mask="_____-___"
												replacement={{ _: /\d/ }}
												name="cep"
												autoComplete="off"
												value={formData.cep}
												className="form-control"
												onBlur={buscarEndereco}
												onChange={handleChange}
												placeholder="XXXXX-XXX"
											/>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Estado</label>
											<select
												name="estado"
												className="form-control"
												value={formData.estado}
												onChange={handleChange}
											>
												<option value="">Selecione...</option>
												{estados.map((option, index) => (
													<option key={index} value={option}>
														{option}
													</option>
												))}
											</select>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Cidade</label>
											<input
												type="text"
												className="form-control"
												name="cidade"
												value={formData.cidade}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Bairro</label>
											<input
												type="text"
												name="bairro"
												className="form-control"
												value={formData.bairro}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-5 col-12">
											<label className="form-label fw-bold">Rua</label>
											<input
												type="text"
												name="rua"
												className="form-control"
												value={formData.rua}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-2 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Número</label>
											<input
												type="text"
												name="numero"
												className="form-control"
												value={formData.numero}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-5 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Complemento</label>
											<input
												type="text"
												name="complemento"
												className="form-control"
												value={formData.complemento}
												onChange={handleChange}
											/>
										</div>
									</div>

									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Observações</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-12">
											<textarea
												name="observacao"
												className="form-control"
												autoComplete="off"
												value={formData.observacao}
												onChange={handleChange}
												rows="3"
											></textarea>
										</div>
									</div>
								</>
							)}

							{activeTab === 'cliente' && (
								<>
									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Dados do Cliente</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											<label className="form-label fw-bold">RG</label>
											<InputMask
												mask="__.___.___-_"
												replacement={{ _: /\d/ }}
												type="text"
												name="rg"
												className="form-control"
												value={formData.rg}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Profissão</label>
											<input
												type="text"
												name="profissao"
												className="form-control"
												value={formData.profissao}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Como Conheceu?</label>
											<select
												name="como_conheceu"
												className="form-control"
												value={formData.como_conheceu}
												onChange={handleChange}
											>
												<option value="">Selecione...</option>
												{opcoesOndeConheceu.map((opcao) => (
													<option key={opcao.id} value={opcao.id}>
														{opcao.valor}
													</option>
												))}
											</select>
										</div>
									</div>
									{/*<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											{formData.sistema_origem ? (
												<>
													<div>
														<label className="form-label fw-bold">Sistema de Origem</label>
													</div>
													<div>
														<span className={`badge ${formData.sistema_origem === 'CORTE' ? 'bg-primary-custom' : 'bg-success'}`} style={{ fontSize: '1rem', padding: '0.5rem' }}>
															{formData.sistema_origem === 'CORTE' ? 'CÔRTE' : 'MEU VISAGISMO'}
														</span>
													</div>
												</>
											) : (
												<></>
											)}
										</div>
									</div>*/}

									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Fotos Adicionais</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-6 col-12 mb-3">
											<label className="form-label fw-bold">Foto 2</label>
											{formData.fotodois ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fotodois}
															alt="Foto 2"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fotodois)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fotodois: '' })}
														>
															<FaRegTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(1)}>
													{loadingImage['fotodois'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fotodois')}
																ref={(el) => (fileInputRefs.current[1] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>

										<div className="col-lg-4 col-md-6 col-12 mb-3">
											<label className="form-label fw-bold">Foto 3</label>
											{formData.fototres ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fototres}
															alt="Foto 3"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fototres)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fototres: '' })}
														>
															<FaTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(2)}>
													{loadingImage['fototres'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fototres')}
																ref={(el) => (fileInputRefs.current[2] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>

										<div className="col-lg-4 col-md-6 col-12 mb-3">
											<label className="form-label fw-bold">Foto 4</label>
											{formData.fotoquatro ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fotoquatro}
															alt="Foto 4"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fotoquatro)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fotoquatro: '' })}
														>
															<FaTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(3)}>
													{loadingImage['fotoquatro'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fotoquatro')}
																ref={(el) => (fileInputRefs.current[3] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>

										<div className="col-lg-4 col-md-6 col-12 mb-3">
											<label className="form-label fw-bold">Foto 5</label>
											{formData.fotocinco ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fotocinco}
															alt="Foto 5"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fotocinco)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fotocinco: '' })}
														>
															<FaTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(4)}>
													{loadingImage['fotocinco'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fotocinco')}
																ref={(el) => (fileInputRefs.current[4] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>

										<div className="col-lg-4 col-md-6 col-12 mb-3">
											<label className="form-label fw-bold">Foto 6</label>
											{formData.fotoseis ? (
												<div className="foto-box">
													<div className="photo-preview-container">
														<img
															src={formData.fotoseis}
															alt="Foto 6"
															className="foto-preview"
															onClick={() => handleOpenImage(formData.fotoseis)}
														/>
														<button
															type="button"
															className="foto-remove-btn"
															onClick={() => setFormData({ ...formData, fotoseis: '' })}
														>
															<FaTrashAlt />
														</button>
													</div>
												</div>
											) : (
												<div className="foto-box" onClick={() => handleBlockClick(5)}>
													{loadingImage['fotoseis'] ? (
														<div className="spinner-border text-secondary"></div>
													) : (
														<div className="foto-preview-container">
															<input
																type="file"
																accept="image/*"
																onChange={(e) => handleFileChange(e, 'fotoseis')}
																ref={(el) => (fileInputRefs.current[5] = el)}
															/>
														</div>
													)}
												</div>
											)}
										</div>
									</div>
								</>
							)}

							{activeTab === 'colaborador' && (
								<>
									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Dados do Colaborador</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											<label className="form-label fw-bold">Senha</label>
											<input
												type="password"
												name="senha"
												className="form-control"
												value={formData.senha}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Tipo PIX</label>
											<select
												name="tipo_pix"
												className="form-control"
												value={formData.tipo_pix}
												onChange={handleChange}
											>
												<option value="">Selecione...</option>
												<option value="CPF">CPF</option>
												<option value="CNPJ">CNPJ</option>
												<option value="Email">Email</option>
												<option value="Telefone">Telefone</option>
												<option value="Chave Aleatória">Chave Aleatória</option>
											</select>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">PIX</label>
											<input
												type="text"
												name="pix"
												className="form-control"
												value={formData.pix}
												onChange={handleChange}
												placeholder="Digite a chave PIX..."
											/>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											<label className="form-label fw-bold">Tipo de Acesso</label>
											<select
												name="tipo_acesso_id"
												className="form-control"
												value={formData.tipo_acesso_id}
												onChange={handleChange}
											>
												<option value="">Selecione...</option>
												{Array.isArray(tiposAcesso) && tiposAcesso.map((tipo) => (
													<option key={tipo.id} value={tipo.id}>
														{tipo.nome}
													</option>
												))}
											</select>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Gestora</label>
											<select
												name="gestora_designacao_id"
												className="form-control"
												value={formData.gestora_designacao_id}
												onChange={(e) => handleSelectChange('gestora_designacao_id', e.target.value)}
											>
												<option value="">Selecione...</option>
												{gestorasOptions.map((gestora) => (
													<option key={gestora.id} value={gestora.id}>
														{gestora.nome}
													</option>
												))}
											</select>
										</div>
									</div>

									{formData.e_colaborador && (
										<div className="row mt-4">
											<div className="col-12">
												<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-end mb-3">
													<div>
														<h6 className="fw-bold mb-1">Unidades Vinculadas</h6>
														<p className="text-muted mb-2 mb-lg-0">Configure as unidades onde o colaborador pode trabalhar</p>
													</div>
													<button
														type="button"
														className="btn btn-outline-primary align-self-end mt-2 mt-lg-0"
														onClick={handleAdicionarUnidadeVinculada}
													>
														<FaPlus /> Adicionar Unidade
													</button>
												</div>
											</div>
										</div>
									)}

									{formData.unidadesVinculadas && formData.unidadesVinculadas.length > 0 && (
										<div className="row mt-3">
											<div className="col-12">
												<div className="table-responsive">
													<table className="table table-striped">
														<thead className="table-custom-primary">
															<tr>
																<th>Unidade</th>
																<th className="text-center">Ações</th>
															</tr>
														</thead>
														<tbody>
															{formData.unidadesVinculadas.map((unidade) => (
																<tr key={unidade.id}>
																	<td>
																		<select
																			className="form-select"
																			value={unidade.unidade_id ? String(unidade.unidade_id) : ''}
																			onChange={(e) => handleChangeUnidadeVinculada(unidade.id, e.target.value)}
																		>
																			<option value="" hidden>Selecione...</option>
																			{unidadesOptions
																				.filter(opcaoUnidade => {
																					const jaUsada = formData.unidadesVinculadas.some(outraUnidade => 
																						outraUnidade.id !== unidade.id && 
																						String(outraUnidade.unidade_id) === String(opcaoUnidade.id)
																					);
																					return !jaUsada;
																				})
																				.map((opcaoUnidade) => (
																				<option key={opcaoUnidade.id} value={String(opcaoUnidade.id)}>
																					{opcaoUnidade.nome}
																				</option>
																			))}
																		</select>
																	</td>
																	<td className="text-center">
																		<button
																			type="button"
																			className="btn btn-custom-secondary btn-sm"
																			onClick={() => handleRemoverUnidadeVinculada(unidade.id)}
																		>
																			<FaTrashAlt />
																		</button>
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									)}

									<div className="row mt-4">
										<div className="col-12">
											<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-end mb-3">
												<div>
													<h6 className="fw-bold mb-1">Horários Padrão</h6>
													<p className="text-muted mb-2 mb-lg-0">Configure os horários regulares de trabalho</p>
												</div>
												<button
													type="button"
													className="btn btn-outline-primary align-self-end mt-2 mt-lg-0"
													onClick={handleAdicionarHorarioPadrao}
												>
													<FaPlus /> Adicionar Horário Padrão
												</button>
											</div>
										</div>
									</div>

									{formData.horariosPadrao.length > 0 && (
										<div className="row mt-3">
											<div className="col-12">
												<div className="table-responsive">
													<table className="table table-striped">
														<thead className="table-custom-primary">
															<tr>
																<th style={{minWidth: '250px'}}>Unidade</th>
																<th className="text-nowrap" style={{width: '180px'}}>Horário de Início</th>
																<th className="text-nowrap" style={{width: '180px'}}>Horário de Término</th>
																<th style={{minWidth: '300px'}}>Dias da Semana</th>
																<th className="text-center" style={{width: '100px'}}>Ações</th>
															</tr>
														</thead>
														<tbody>
															{formData.horariosPadrao.map((horario) => (
																<tr key={horario.id}>
																	<td>
																		<select
																			className="form-select"
																			value={horario.unidade_id || ''}
																			onChange={(e) => handleChangeHorarioPadrao(horario.id, 'unidade_id', e.target.value)}
																		>
																			<option value="">Selecione...</option>
																			{unidadesOptions
																				.filter(unidade => 
																					formData.unidadesVinculadas.some(vinculada => 
																						String(vinculada.unidade_id) === String(unidade.id)
																					)
																				)
																				.map((unidade) => (
																				<option key={unidade.id} value={unidade.id}>
																					{unidade.nome}
																				</option>
																			))}
																		</select>
																	</td>
																	<td>
																		<TimePicker
																			value={stringToTime(horario.hora_inicio)}
																			onChange={(date) => handleTimeChangeHorarioPadrao(horario.id, 'hora_inicio', date)}
																			timeIntervals={15}
																			className="form-control"
																			strategy="fixed"
																		/>
																	</td>
																	<td>
																		<TimePicker
																			value={stringToTime(horario.hora_termino)}
																			onChange={(date) => handleTimeChangeHorarioPadrao(horario.id, 'hora_termino', date)}
																			timeIntervals={15}
																			className="form-control"
																			strategy="fixed"
																		/>
																	</td>
																	<td>
																		<div className="d-flex flex-column gap-2">
																			<div className="d-flex gap-2">
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.segunda}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'segunda', e.target.checked)}
																					/>
																					<label className="form-check-label">Seg</label>
																				</div>
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.terca}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'terca', e.target.checked)}
																					/>
																					<label className="form-check-label">Ter</label>
																				</div>
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.quarta}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'quarta', e.target.checked)}
																					/>
																					<label className="form-check-label">Qua</label>
																				</div>
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.quinta}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'quinta', e.target.checked)}
																					/>
																					<label className="form-check-label">Qui</label>
																				</div>
																			</div>
																			<div className="d-flex gap-2">
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.sexta}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'sexta', e.target.checked)}
																					/>
																					<label className="form-check-label">Sex</label>
																				</div>
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.sabado}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'sabado', e.target.checked)}
																					/>
																					<label className="form-check-label">Sáb</label>
																				</div>
																				<div className="form-check form-check-inline">
																					<input
																						className="form-check-input"
																						type="checkbox"
																						checked={horario.dias_semana.domingo}
																						onChange={(e) => handleChangeDiaSemana(horario.id, 'domingo', e.target.checked)}
																					/>
																					<label className="form-check-label">Dom</label>
																				</div>
																			</div>
																		</div>
																	</td>
																	<td className="text-center">
																		<button
																			type="button"
																			className="btn btn-custom-secondary btn-sm"
																			onClick={() => handleRemoverHorarioPadrao(horario.id)}
																		>
																			<FaTrashAlt />
																		</button>
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									)}


									<div className="row mt-4">
										<div className="col-12">
											<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-end mb-3">
												<div>
													<h6 className="fw-bold mb-1">Horários de Exceção</h6>
													<p className="text-muted mb-2 mb-lg-0">Configure datas específicas com horários diferentes ou folgas</p>
												</div>
												<button
													type="button"
													className="btn btn-outline-primary align-self-end mt-2 mt-lg-0"
													onClick={handleAdicionarHorarioExcecao}
												>
													<FaPlus /> Adicionar Horário de Exceção
												</button>
											</div>
										</div>
									</div>

									{formData.horariosExcecao.length > 0 && (
										<div className="row mt-3">
											<div className="col-12">
												<div className="table-responsive">
													<table className="table table-striped">
														<thead className="table-custom-primary">
															<tr>
																<th style={{minWidth: '220px'}}>Unidade</th>
																<th style={{minWidth: '150px'}}>Data</th>
																<th style={{minWidth: '200px'}}>Tipo</th>
																<th className="text-nowrap" style={{width: '160px'}}>Horário de Início</th>
																<th className="text-nowrap" style={{width: '160px'}}>Horário de Término</th>
																<th style={{width: '100px'}}>Ações</th>
															</tr>
														</thead>
														<tbody>
															{formData.horariosExcecao.map((horario) => (
																<tr key={horario.id}>
																	<td>
																		<select
																			className="form-select"
																			value={horario.unidade_id || ''}
																			onChange={(e) => handleChangeHorarioExcecao(horario.id, 'unidade_id', e.target.value)}
																		>
																			<option value="">Selecione...</option>
																			{unidadesOptions
																				.filter(unidade => 
																					formData.unidadesVinculadas.some(vinculada => 
																						String(vinculada.unidade_id) === String(unidade.id)
																					)
																				)
																				.map((unidade) => (
																				<option key={unidade.id} value={unidade.id}>
																					{unidade.nome}
																				</option>
																			))}
																		</select>
																	</td>
																	<td>
																		<DatePicker
																			selected={dateHelpers.stringToDate(horario.data_especifica)}
																			onChange={dateHelpers.createOnChangeHandler((formattedDate) =>
																				handleDateChangeHorarioExcecao(horario.id, formattedDate)
																			)}
																			className="form-control"
																			popperProps={{
																				strategy: "fixed"
																			}}
																		/>
																	</td>
																	<td>
																		<select
																			className="form-select"
																			value={horario.tipo_excecao}
																			onChange={(e) => handleChangeHorarioExcecao(horario.id, 'tipo_excecao', e.target.value)}
																		>
																			<option value="">Selecione...</option>
																			<option value="horario_diferente">Horário Diferente</option>
																			<option value="folga">Folga</option>
																			<option value="feriado">Feriado</option>
																		</select>
																	</td>
																	<td>
																		<TimePicker
																			value={stringToTime(horario.hora_inicio)}
																			onChange={(date) => handleTimeChangeHorarioExcecao(horario.id, 'hora_inicio', date)}
																			timeIntervals={15}
																			className="form-control"
																			disabled={horario.tipo_excecao === 'folga' || horario.tipo_excecao === 'feriado'}
																		/>
																	</td>
																	<td>
																		<TimePicker
																			value={stringToTime(horario.hora_termino)}
																			onChange={(date) => handleTimeChangeHorarioExcecao(horario.id, 'hora_termino', date)}
																			timeIntervals={15}
																			className="form-control"
																			disabled={horario.tipo_excecao === 'folga' || horario.tipo_excecao === 'feriado'}
																		/>
																	</td>
																	<td className="text-center">
																		<button
																			type="button"
																			className="btn btn-custom-secondary btn-sm"
																			onClick={() => handleRemoverHorarioExcecao(horario.id)}
																		>
																			<FaTrashAlt />
																		</button>
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									)}


								</>
							)}

							{activeTab === 'fornecedor' && (
								<>
									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Dados do Fornecedor</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-4 col-md-12">
											<label className="form-label fw-bold">Nome Fantasia</label>
											<input
												type="text"
												name="nome_fantasia"
												className="form-control"
												value={formData.nome_fantasia}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Razão Social</label>
											<input
												type="text"
												name="razao_social"
												className="form-control"
												value={formData.razao_social}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Responsável</label>
											<input
												type="text"
												name="responsavel"
												className="form-control"
												value={formData.responsavel}
												onChange={(e) => setFormData({ ...formData, responsavel: e.target.value.toUpperCase() })}
											/>
										</div>
									</div>

									<div className="row mt-4">
										<div className="col-12">
											<h6 className="fw-bold">Dados Bancários</h6>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-6 col-12">
											<label className="form-label fw-bold">Banco</label>
											<Select
												options={bancosOptions}
												styles={customStyles}
												onInputChange={(value) => {
													handleAutoCompleteBancos(value);
												}}
												onFocus={handleFocusBancos}
												onChange={(value) => handleSelectChange('banco', value)}
												placeholder="Digite o nome do banco"
												isClearable
												menuPlacement="auto"
												menuPosition="fixed"
												noOptionsMessage={() => "Sem opções"}
												value={formData.banco}
											/>
										</div>
										<div className="col-lg-4 col-12 mt-lg-0 mt-3">
											<div>
												<label className="form-label fw-bold">Tipo de Conta</label>
											</div>
											<div className="form-check form-check-inline">
												<input
													className="form-check-input"
													type="radio"
													name="tipo_conta"
													value="corrente"
													checked={formData.tipo_conta === "corrente"}
													onChange={handleChange}
												/>
												<label className="form-check-label">Corrente</label>
											</div>
											<div className="form-check form-check-inline">
												<input
													className="form-check-input"
													type="radio"
													name="tipo_conta"
													value="poupanca"
													checked={formData.tipo_conta === "poupanca"}
													onChange={handleChange}
												/>
												<label className="form-check-label">Poupança</label>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-3 col-12">
											<label className="form-label fw-bold">Agência</label>
											<input
												type="text"
												className="form-control"
												name="agencia"
												value={formData.agencia}
												onChange={handleChange}
											/>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Conta</label>
											<div className="d-flex">
												<input
													type="text"
													name="conta"
													className="form-control"
													value={formData.conta}
													onChange={handleChange}
												/>
												<input
													type="text"
													name="conta_digito"
													className="form-control w-auto ms-2"
													style={{ maxWidth: "80px" }}
													maxLength={1}
													value={formData.conta_digito}
													onChange={handleChange}
												/>
											</div>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Nome do Titular</label>
											<input
												type="text"
												className="form-control"
												name="nome_titular"
												value={formData.nome_titular}
												onChange={(e) => setFormData({ ...formData, nome_titular: e.target.value.toUpperCase() })}
											/>
										</div>
										<div className="col-lg-3 col-12 mt-lg-0 mt-3">
											<label className="form-label fw-bold">Documento do Titular</label>
											<input
												type="text"
												name="documento_titular"
												className="form-control"
												value={formData.documento_titular}
												onChange={handleChange}
											/>
										</div>
									</div>
								</>
							)}
						</form>
					</div>

					<div className="modal-footer mt-4">
						<div className="row">
							<div className="col-12 text-end">
								<button className="btn btn-outline-danger" type="button" onClick={onClose}>
									<FaTimes /> Fechar
								</button>
								<button className="btn btn-custom-primary ms-3" type="submit" disabled={isLoading} onClick={handleSubmit}>
									<FaRegSave /> Salvar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div >
	);
};

export default PessoaModal; 